import { createFileRoute, redirect } from "@tanstack/react-router";

// /sales/new redirige a la ruta de edición en modo "new". Así el borrador vive
// bajo /sales/$id/edit y, al crearse, la URL puede sincronizarse al id real sin
// remontar (evita drafts huérfanos al recargar). Espejo de /invoices/new.
export const Route = createFileRoute("/_authenticated/sales/new")({
  beforeLoad: () => {
    throw redirect({
      to: "/sales/$id/edit",
      params: { id: "new" },
    });
  },
});
